// formValidation.js de FeeContractForm

export const validateForm = (formData, errors) => {
    let newErrors = { ...errors };

    // Validación de datos del responsable
    if (!formData.responsibleName?.trim() || !formData.responsiblePosition?.trim()) {
        newErrors.responsibleInfo = 'El nombre y el cargo del responsable son obligatorios.';
    } else {
        delete newErrors.responsibleInfo;
    }

    // Validación contrato
    const contractErrors = [];
    if (!formData.professionalName?.trim()) contractErrors.push('nombre del profesional');
    if (!formData.professionalRut?.trim()) contractErrors.push('RUT del profesional');
    if (!formData.hoursPerMonth) contractErrors.push('número de horas por mes');
    if (!formData.monthlyAmount) contractErrors.push('monto de pago mensual');
    if (!formData.numberOfMonths) contractErrors.push('número de meses');

    // Calcular el monto total del contrato
    const totalAmount = (parseInt(formData.monthlyAmount) || 0) * (parseInt(formData.numberOfMonths) || 0);

    // Si hay campos obligatorios faltantes
    if (contractErrors.length > 0) {
        newErrors.contract = `Campos obligatorios faltantes: ${contractErrors.join(', ')}`;
    } else {
        // Si todos los campos obligatorios están llenos, verificar el monto total
        if (formData.monthlyAmount && formData.numberOfMonths && totalAmount <= 0) {
            newErrors.contract = 'El monto total del contrato debe ser mayor a 0';
        } else if (totalAmount > 0) {
            delete newErrors.contract;
        }
    }

    // Validación de documentos oficiales
    if (formData.attachments.officialDocs.length === 0) {
        newErrors.officialDocs = 'Debe adjuntar al menos un documento oficial.';
    } else {
        delete newErrors.officialDocs;
    }

    return {
        isValid: Object.keys(newErrors).length === 0,
        newErrors
    };
};